import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { PropertyService } from '../../services/property.service';
import { LesseeService } from '../../services/lessee.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent implements OnInit {
  @Input()
  conversation;

  @Input()
  property;

  @Input()
  respondMode: boolean = false;

  @Output()
  onCancel = new EventEmitter<void>();

  @Output()
  onSend = new EventEmitter<void>();

  responseMedium = 'email';

  response;

  constructor(private propertyService: PropertyService, private lesseeService: LesseeService, private authService: AuthService) { }

  ngOnInit() {
    if(this.authService.isAdmin()) {
      this.propertyService.markConversationAsRead(this.property, this.conversation);
    } else {
      this.lesseeService.markConversationAsRead(this.property, this.conversation);
    }
  }

  respondAction() {
    this.respondMode = true;
  }

  cancelAction() {
    this.respondMode = false;

    if(this.onCancel) {
      this.onCancel.emit();
    }
  }

  sendAction() {
    if(this.authService.isAdmin()) {
      this.propertyService.respondToConversation(this.property, this.conversation, this.response, this.responseMedium).then((res) => {
        this.respondMode = false;
  
        if(this.onSend) {
          this.onSend.emit();
        }
      });
    } else {
      this.lesseeService.respondToConversation(this.property, this.conversation, this.response, this.responseMedium).then((res) => {
        this.respondMode = false;
  
        if(this.onSend) {
          this.onSend.emit();
        }
      });
    }
  }
}
